import React from "react";
import ReusableTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/Reusable.component";

const Body = ({
  ScolarshipColumns,
  ScolarShipStudents,
  FeeWaiverColumns,
  FeeWaiverStudents,
}) => {
  return (
    <div
      style={{
        display: "flex",
        marginTop: "1rem",
        marginBottom: "1rem",
        gap: "1rem",
      }}
    >
      <ReusableTable
        title="Scholarship holding students"
        countLabel={`${ScolarShipStudents.length} persons`}
        columns={ScolarshipColumns}
        data={ScolarShipStudents}
        renderedElement={
          <div
            style={{ marginLeft: "auto", marginTop: "1rem" }}
            className="yellowInfoBox"
          >
            <span className="info-title">
              Total holding scholarship amount:
            </span>{" "}
            ₹ 2,60,560
          </div>
        }
      />
      <ReusableTable
        title="Scholarship holding students"
        countLabel={`${FeeWaiverStudents.length} persons`}
        columns={FeeWaiverColumns}
        data={FeeWaiverStudents}
        renderedElement={
          <div
            style={{ marginLeft: "auto", marginTop: "1rem" }}
            className="lightBlueInfoBox"
          >
            <span className="info-title">Total fee waivers amount:</span> ₹
            2,60,560
          </div>
        }
      />
    </div>
  );
};

export default Body;
